import { useMemo } from 'react';

import { Grid } from '@mui/material';
import { FormikProps } from 'formik';
import * as Yup from 'yup';

import { CissNumberField } from 'components/fields';
import { Row } from 'components/form';
import { Block, FormPage } from 'components/page';
import { useMutateConfiguracaoMinimo } from 'pages/compra/configuracao-minimo/hooks';
import { ConfiguracaoMinimo, initialConfiguracaoMinimo } from 'pages/compra/configuracao-minimo/types';

export function ConfiguracaoMinimoFormComp() {
    const { onSubmit } = useMutateConfiguracaoMinimo();

    const validationSchema = useMemo(
        () =>
            Yup.object({
                vlPesoTotalPedidoMinimo: Yup.number(),
                vlTotalPedidoMinimo: Yup.number(),
            }),
        [],
    );

    return (
        <FormPage
            goBackButton
            keepOriginalTitle
            queryWithId={false}
            url="/gestao/configuracaogeralpedidominimo/ativo"
            title="Configuração de Mínimos"
            onSubmit={onSubmit}
            values={initialConfiguracaoMinimo}
            validationSchema={validationSchema}
        >
            {({ values, setFieldValue, errors }: FormikProps<ConfiguracaoMinimo>) => (
                <Block>
                    <Row sx={{ mb: 0 }}>
                        <Grid sx={{ flex: 1 }}>
                            <CissNumberField
                                name="vlPesoTotalPedidoMinimo"
                                label="Peso mínimo (Kg)"
                                inputType="decimal"
                                decimalPrecision={3}
                                value={values.vlPesoTotalPedidoMinimo}
                                error={errors.vlPesoTotalPedidoMinimo}
                                onChange={(e) => setFieldValue('vlPesoTotalPedidoMinimo', Number(e.target.value || 0))}
                            />
                        </Grid>

                        <Grid sx={{ flex: 1 }}>
                            <CissNumberField
                                name="vlTotalPedidoMinimo"
                                label="Valor mínimo (R$)"
                                inputType="decimal"
                                value={values.vlTotalPedidoMinimo}
                                error={errors.vlTotalPedidoMinimo}
                                onChange={(e) => setFieldValue('vlTotalPedidoMinimo', Number(e.target.value || 0))}
                            />
                        </Grid>
                    </Row>
                </Block>
            )}
        </FormPage>
    );
}
